import { IDanhSachNganh2ViewModel } from "../../../model/response/quan-ly-nganh-2/IDanhSachNganh2ViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachNganh2ActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDanhSachNganh2ViewModel[],
    LOAD_ERROR: "",

    CHANGE_TAB: {} as "dot-dang-ky" | "duyet-dang-ky" | "danh-sach-nganh-2",
}

export const eDanhSachNganh2ActionIds = generateActionTypeIds(eDanhSachNganh2ActionsObj, "DANH_SACH_NGANH_2");
export type IDanhSachNganh2ActionTypes = IGenericActionType<typeof eDanhSachNganh2ActionsObj, "DANH_SACH_NGANH_2">;